import React,{useEffect, useState, useRef} from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown} from "react-bootstrap";
import FsLightbox from 'fslightbox-react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import "./PropertyDescription.scss";
import ReactMarkdown from "react-markdown"
import CustomVideoPlay from "@Components/CustomVideo/CustomVideo.js";
import PropertyMap from "@Components/PropertyMap/PropertyMap"
import HTMLReactParser from 'html-react-parser'
import {
    AREAGUIDE_PAGE_URL
  } from "@Components/common/site/constants";
import FloorPlanModal from "@Components/FloorPlanModal/floorPlanModal";
import PropertyTopVideoImgDesktop from "../../../images/propertydetails/proper-details-top-video-d.jpg";
import PropertyTopVideoImgTablet from "../../../images/propertydetails/proper-details-top-video-t.jpg";
import PropertyTopVideoImgMobile from "../../../images/propertydetails/proper-details-top-video-m.jpg";

import PropertyGraphImgDesktop from "../../../images/propertydetails/property-description-graph-d.jpg"
import PropertyGraphImgTablet from "../../../images/propertydetails/property-description-graph-t.jpg"
import PropertyGraphImgMobile from "../../../images/propertydetails/property-description-graph-m.jpg"

import PropertyMapImgDesktop from "../../../images/propertydetails/property-decription-map-d.jpg"
import PropertyMapImgTablet from "../../../images/propertydetails/property-decription-map-m.jpg"
import PropertyMapImgMobile from "../../../images/propertydetails/property-decription-map-t.jpg"

import DescriptionVideoImgDesktop from "../../../images/propertydetails/description-video-d.png"
import DescriptionVideoImgTablet from "../../../images/propertydetails/description-video-t.png"
import DescriptionVideoImgMobile from "../../../images/propertydetails/description-video-m.png"

import GalleryImg1 from "../../../images/propertydetails/gallery-img1.jpg"
import GalleryImg2 from "../../../images/propertydetails/gallery-img2.jpg"
import GalleryImg3 from "../../../images/propertydetails/gallery-img3.jpg"
import GalleryImg4 from "../../../images/propertydetails/gallery-img4.jpg"
import GalleryImg5 from "../../../images/propertydetails/gallery-img5.jpg"
import GalleryImg6 from "../../../images/propertydetails/gallery-img6.jpg"
import GalleryImg7 from "../../../images/propertydetails/gallery-img7.jpg"
import GalleryImg8 from "../../../images/propertydetails/gallery-img8.jpg"
import PlayVideo from '../../../Components/Play/PlayVideo';
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import {ImageModule} from "@Components/common/Image_Module";

const SINGLE_AREA = gql`
query GetAreaDetails ($Prop_Postcode: String!){
    areas (where:{Postcode_contains:$Prop_Postcode}) {
        id
        imagetransforms
        ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
        }
        Name
        URL
    Postcode
    Video_Url
    Modules {
        ... on ComponentModuleServicesCta {
          id
          Content
        }
      }
      Banner_Image {
            url
          alternativeText
        }
    }
}
`;

const PropertyDescription = (props) => {
    const myRefless = useRef(null)
    const readlessScroll = () => {
        myRefless.current.scrollIntoView()
    }
    const [active, setActive] = useState('+ Read More');
    const handleAccordionClick = () => {
        if (active === '+ Read More') {
            setActive('- Read Less')
        } else {
            setActive('+ Read More')
            readlessScroll()
        }
    }
    if (props.data.long_description && props.data.long_description.length < 200) {
        var long_desc_first_part = props.data.long_description;
    }
    else {
        var long_desc_first_part = props.data.long_description ? props.data.long_description.slice(0, 300)+'...' : '';
    }
    // Floorplan lightbox
    const [floorplanIndex, setFloorPlanIndex] = useState(0);
    const [isOpenFloor, setIsOpenFloor] = useState(false);

    const openLighboxMobileFloor = (e, ind) => {
        e.preventDefault();
        setFloorPlanIndex(ind);
        setIsOpenFloor(true);
    }

    var FloorPlanImage = props.data?.floorplan && props.data?.floorplan.map(img => img.url);
    // Floorplan lightbox

        // epcplan lightbox
        const [epcIndex, setepcIndex] = useState(0);
        const [isOpenepc, setIsOpenepc] = useState(false);
    
        const openLighboxMobileepc = (e, ind) => {
            e.preventDefault();
            setepcIndex(ind);
            setIsOpenepc(true);
        }
    
        var epcImage =
          props?.data?.epc &&
          props?.data?.epc?.length > 0 &&
          props?.data?.epc?.map(img =>
            props?.data?.search_type === "lettings" ? img?.srcUrl : img?.url
          )
        // epcplan lightbox
        // Banner lightbox
        const [photoIndex, setPhotoIndex] = useState(0);
        const [isOpen, setIsOpen] = useState(false);
    
        const openLighboxMobile = (e, ind) => {
            e.preventDefault();
            setPhotoIndex(ind);
            setIsOpen(true);
        }
    
        var lightImages2 = props?.data?.images && props?.data?.images.map(img => img.url);
        // Banner lightbox
    const { loading, data } = useQuery(SINGLE_AREA, {
        variables: { Prop_Postcode: props.postcode }
      });

    const [toggler, setToggler] = useState(false);
      const [lightboxController] = useState({
    toggler: false,
    slide: 1
});
var imagesArr = []
for(var i=0; i < props.data?.images.length; i++){
  imagesArr.push(props.data?.images[i].url)
}
    const [isPlay, setPlay] = useState(false);
    const [isPlayed, setPlayed] = useState(false);
    const [isPlaying, setPlaying] = useState(false);

    const settings = {
        dots: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
             {
            breakpoint: 9999,
            settings:"unslick"
            },
        
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
          
        ],
      }

      let processedImages1 = JSON.stringify({});
                        if (props.data?.imagetransforms?.Image_Transforms) {
                            processedImages1 = props.data?.imagetransforms.Image_Transforms;
                          }
    const accomadation_summary = 
                          props.data?.accomadation_summary && 
                          typeof props.data.accomadation_summary === 'string'
                              ? JSON.parse(props.data.accomadation_summary)
                              : props.data.accomadation_summary;
    return (
        <React.Fragment>
            <section  className="property-description">
                {/* {JSON.stringify(props.data?.virtual_tour)} */}
                {/* {JSON.stringify(imagesArr)} */}
            <FsLightbox
        toggler={toggler}
        sources={imagesArr}
        // key={lightboxController.key}
        type='image'
    />
                <Container>
                    <div className="video-box-grid">
                        <div className="video-img-box">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <div className="video-wrap img-hover-zoom">
                           {/* {JSON.stringify(props.data.images)} */}
                           {/* <picture>
                                <source media="(min-width:992px)" srcSet={props?.data?.images[0]?.url} />
                                <source media="(min-width:768px)" srcSet={props?.data?.images[0]?.url} />
                                <img src={props?.data?.images[0]?.url} alt="" />
                            </picture> */}
                            <ImageModule ImageSrc={props?.data?.images[0]} attr={{ alt: props.data?.title }} ggfx_results={props.data.ggfx_results} imagename="property.images.propertyDetails_1" strapi_id={props.data?.id} />

                            {/* <ImageTransform imagesources={props?.data?.images[0]?.url} renderer="srcSet" imagename='property.images.propertyDetails_1'
                              attr={{ alt: '', className: '' }}
                              imagetransformresult={processedImages1} id={props.data?.id} >

                            </ImageTransform> */}
                            {/* {JSON.stringify(props.data)} */}
                            {props.data?.virtual_tour ? 
                            <CustomVideoPlay title={props.data?.title} url={props.data?.virtual_tour}/> : null}
                            <div className="img-icon-lists d-none d-md-block">
                                
                                        <ul>
                                            <li><a href="javascript:void(0)" onClick={(e) => openLighboxMobile(e, 0)}><i class="icon-gallery"></i></a></li>
                                            <li><a href="javascript:void(0)" onClick={(e) => openLighboxMobile(e, 0)}>1/{props.data?.images?.length}</a></li>
                                        </ul>
                                
                                        <ul>
                                            <li><a href="javascript:void(0)" onClick={(e) => openLighboxMobile(e, 0)}><i className="icon-zoom"></i></a></li>
                                        </ul>
                            </div>
                        </div>  
                        </ScrollAnimation>      
                        </div>
                        {isOpen && (
                            <Lightbox
                                mainSrc={lightImages2[photoIndex]}
                                nextSrc={lightImages2[(photoIndex + 1) % lightImages2.length]}
                                prevSrc={lightImages2[(photoIndex + lightImages2.length - 1) % lightImages2.length]}
                                onCloseRequest={() => setIsOpen(false)}
                                onMovePrevRequest={() =>
                                    setPhotoIndex((photoIndex + lightImages2.length - 1) % lightImages2.length)
                                }
                                onMoveNextRequest={() =>
                                    setPhotoIndex((photoIndex + 1) % lightImages2.length)
                                }
                            />
                        )}
                        {isOpenFloor && (
                    <Lightbox
                        mainSrc={FloorPlanImage[floorplanIndex]}
                        nextSrc={FloorPlanImage[(floorplanIndex + 1) % FloorPlanImage.length]}
                        prevSrc={FloorPlanImage[(floorplanIndex + FloorPlanImage.length - 1) % FloorPlanImage.length]}
                        onCloseRequest={() => setIsOpenFloor(false)}
                        onMovePrevRequest={() =>
                            setFloorPlanIndex((floorplanIndex + FloorPlanImage.length - 1) % FloorPlanImage.length)
                        }
                        onMoveNextRequest={() =>
                            setFloorPlanIndex((floorplanIndex + 1) % FloorPlanImage.length)
                        }
                    />
                )}

{isOpenepc && (
                    <Lightbox
                        mainSrc={epcImage[epcIndex]}
                        nextSrc={epcImage[(epcIndex + 1) % epcImage.length]}
                        prevSrc={epcImage[(epcIndex + epcImage.length - 1) % epcImage.length]}
                        onCloseRequest={() => setIsOpenepc(false)}
                        onMovePrevRequest={() =>
                            setepcIndex((epcIndex + epcImage.length - 1) % epcImage.length)
                        }
                        onMoveNextRequest={() =>
                            setepcIndex((epcIndex + 1) % epcImage.length)
                        }
                    />
                )}

                        <div className="aside-images-box">
                            {/* {JSON.stringify(props.data?.floorplan)} */}
                            {props.data?.floorplan[0]?.url ?
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="graph-img-box">
                            {/* <picture>
                                <source media="(min-width:992px)" srcSet={props.data?.floorplan[0]?.url} />
                                <source media="(min-width:768px)" srcSet={props.data?.floorplan[0]?.url} />
                                <img src={props.data?.floorplan[0]?.url} alt="" />
                            </picture> */}
                            <ImageModule ImageSrc={props?.data?.floorplan[0]} attr={{ alt: props.data?.title }} ggfx_results={props.data.ggfx_results} imagename="property.images.floorplantail" strapi_id={props.data?.id} />
                            {/* <ImageTransform imagesources={props.data?.floorplan[0]?.url} renderer="srcSet" imagename='property.images.floorplantail'
                              attr={{ alt: '', className: '' }}
                              imagetransformresult={processedImages1} id={props.data?.id} >

                            </ImageTransform> */}
                            {props.data?.floorplan[0]?.url ?<a onClick={(e) => openLighboxMobileFloor(e, 0)} className="zoom-icon"><i className="icon-zoom"></i></a> : null}
                            
                            {/* <FloorPlanModal floorplanimg={props.data?.floorplan[0]?.url} /> */}
                            </div>
                        </ScrollAnimation>  : null} 
                        {/* {props.property_latitude} - {props.property_longitude} */}
                            {/* {props.property_latitude && props.property_longitude && */}
                        {/* <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="img-map-box  img-hover-zoom">
                            <PropertyMap
                        property_map_lat={props.property_latitude}
                        property_map_lng={props.property_longitude}
                    />
                            </div>
                        </ScrollAnimation>       */}
{/* } */}
                            {props?.data?.epc?.length > 0 ?
                                <ScrollAnimation className="epc" animateOnce={true} animateIn="fadeIn">
                                    <div className="graph-img-box">
                                    {props?.data?.search_type === "lettings" && props?.data?.epc[0]?.srcUrl
                                    ? <img src={props?.data?.epc[0]?.srcUrl} alt="EPC"/>
                                    : props?.data?.epc[0]?.url ?
                                        <ImageModule ImageSrc={props?.data?.epc[0]} attr={{ alt: props.data?.title }} ggfx_results={props.data.ggfx_results} imagename="property.images.floorplantail" strapi_id={props.data?.id} />
                                        // <ImageTransform
                                        //     imagesources={props?.data?.epc[0]?.url} renderer="srcSet" imagename='property.images.floorplantail'
                                        //     attr={{ alt: '', className: '' }} imagetransformresult={processedImages1} id={props?.data?.id} >
                                        // </ImageTransform>
                                    : null
                                    }
                                    {props?.data?.epc[0]?.srcUrl || props?.data?.epc[0]?.url ?<a onClick={(e) => openLighboxMobileepc(e, 0)} className="zoom-icon"><i className="icon-zoom"></i></a> : null}
                                    </div>
                                </ScrollAnimation>
                            : null}
                        </div>
                    </div>
                    
                    <div id="scroll_view" ref={props.detailsRef} className="property-description-content">
                        <div className="property-description-col-1">
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                            <div className="content">
                            <div ref={myRefless}></div>
                                <h2>Property Description</h2> 
                                {/* {JSON.stringify(props?.data?.long_description)} */}
                                {/* {active === '+ Read More' ?<ReactMarkdown source={props.data.long_description.replaceAll('&rsquo;','’').replaceAll('&lsquo;','‘').slice(0, 300)+'...'} allowDangerousHtml /> :
                                <ReactMarkdown source={props?.data?.long_description.replaceAll('&rsquo;','’').replaceAll('&lsquo;','‘')} allowDangerousHtml /> }
                                    {props?.data?.long_description?.length > 200 && <a className="read-more btn-text-link" onClick={handleAccordionClick}>{active}</a>} */}
                                    
                                    {props?.data?.crm_provider == 'reapit' ?
                                        <>
                                            {active === '+ Read More' ? <><div dangerouslySetInnerHTML={{ __html: props?.data?.description.replaceAll("<strong></strong> <strong></strong> ", "").slice(0, 300) + '...' }} />
                                            </>
                                                :
                                                <>
                                                    <div dangerouslySetInnerHTML={{ __html: props?.data?.description.replaceAll("<strong></strong> <strong></strong> ", "") }} /><br />
                                                    <div dangerouslySetInnerHTML={{ __html: props?.data?.long_description.replaceAll("<strong></strong> <strong></strong> ", "") }} />
                                                </>
                                            }
                                            {(props?.data?.description?.length > 200 || props?.data?.long_description?.length > 200) && <a className="read-more btn-text-link" onClick={handleAccordionClick}>{active}</a>}
                                        </>
                                        :
                                        <>
                                            {active === '+ Read More' ? <><div dangerouslySetInnerHTML={{ __html: props?.data?.long_description.replaceAll("<strong></strong> <strong></strong> ", "").slice(0, 300) + '...' }} />

                                            </>
                                                : <div dangerouslySetInnerHTML={{ __html: props?.data?.long_description.replaceAll("<strong></strong> <strong></strong> ", "") }} />}
                                            {props?.data?.long_description?.length > 200 && <a className="read-more btn-text-link" onClick={handleAccordionClick}>{active}</a>}
                                        </>
                                    }
                            </div>
                        </ScrollAnimation> 
                        {data && data.areas && data.areas.map((areaguide, key) => {
                             if(key == 0) {
                                let processedImages = JSON.stringify({});
                                if (areaguide?.imagetransforms?.Image_Transforms) {
                                    processedImages = areaguide.imagetransforms.Image_Transforms;
                                  }
                                return(
                                <>   
                                {areaguide?.Modules[0]?.Content &&
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                            <div className="local-life">
                            <Row> 
                            {areaguide.Banner_Image?.url ?
                            <Col className="column-video" md={3} xl={3}>       
                            <div className="video-small-property-description"  onClick={(e) => {setPlayed(true)}}>
                                <div className="areaguide video-wrap img-hover-zoom">
                                    {/* <picture>
                                        <source media="(min-width:992px)" srcSet={areaguide.Banner_Image?.url} />
                                        <source media="(min-width:768px)" srcSet={areaguide.Banner_Image?.url} />
                                        <img src={areaguide.Banner_Image?.url} alt="" />
                                    </picture> */}
                                    <ImageModule ImageSrc={areaguide.Banner_Image} attr={{ alt: areaguide.Name }} ggfx_results={areaguide.ggfx_results} imagename="areas.Banner_Image.detail" strapi_id={areaguide.id} />
                                    {/* <ImageTransform imagesources={areaguide.Banner_Image?.url} renderer="srcSet" imagename='areas.Banner_Image.detail'
                              attr={{ alt: areaguide.Banner_Image?.alternativeText, className: '' }}
                              imagetransformresult={processedImages} id={areaguide.id} ></ImageTransform> */}
                                </div>
                                {areaguide.Video_Url ?
                                <CustomVideoPlay title={areaguide.Name} url={areaguide.Video_Url}/> : null}
                                {/* <span class="video-btn"><i class="icon-video"></i></span>  */}
                            </div>
                            </Col>
                            : null}
                            
                            <Col className="column-text" md={areaguide.Banner_Image?.url ? 9 : 12} xl={areaguide.Banner_Image?.url ? 9 : 12}>
                            <div className="local-life-text-content">
                                <h3>{areaguide.Name}</h3>
                                <p className="text-light1">
                                <ReactMarkdown source={areaguide?.Modules[0]?.Content} allowDangerousHtml />
                                <Link to={AREAGUIDE_PAGE_URL.alias+'/'+areaguide.URL} className="read-more btn-text-link">Read More</Link>
                                    </p>
                                    {/* <Link className="read-more btn-text-link">Read More</Link> */}
                            </div>
                            </Col>
                            </Row>
                            </div>
                        </ScrollAnimation>
                             }
                        </>
        )
      }
      })}      

                            
                        </div>
                        {accomadation_summary?.length > 0 &&
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                        <div className="property-description-col-2 keyfeatures">
                            <h2>Key Features</h2>
                            <ul>
                            {accomadation_summary && accomadation_summary.map((list, i) => {
                                return(
                                    list?<li><i className="icon-check"></i> <span>{HTMLReactParser(list)}</span></li> : null
                                )
                            })}
                             </ul>
                        </div>
                        </ScrollAnimation>
                        }
                                                    {/* {props.data?.epc[0]?.url ?
                                                    <div className="aside-images-box epc">
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="graph-img-box">
                            <ImageTransform imagesources={props.data?.epc[0]?.url} renderer="srcSet" imagename='property.images.floorplantail'
                              attr={{ alt: '', className: '' }}
                              imagetransformresult={processedImages1} id={props.data?.id} >

                            </ImageTransform>
                            {props.data?.epc[0]?.url ?<a onClick={(e) => openLighboxMobileepc(e, 0)} className="zoom-icon"><i className="icon-zoom"></i></a> : null}
                            
                            </div>
                        </ScrollAnimation> </div>  : null}  */}
                        
                    </div>
                    
                </Container>
                <Container>
                    <div id="scroll_view" ref={props.galleryRef} className="property-description-gallery">
                    <Slider {...settings}>
                        {props?.data?.images && props?.data?.images.map((hit, i) => {
                            let processedImages2 = JSON.stringify({});
                            if (props?.data?.imagetransforms?.Image_Transforms) {
                                processedImages2 = props?.data?.imagetransforms.Image_Transforms;
                              }
                            //   console.log(props, "test");
                                return (
                    <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                        <div className="slider-container">
                            <div className="img-gallery-box">
                                <div className="video-wrap img-hover-zoom">
                                    {/* <picture>
                                        <source media="(min-width:992px)" srcSet={hit.url} />
                                        <source media="(min-width:768px)" srcSet={hit.url} />
                                        <img src={hit.url} alt="" />
                                    </picture> */}
                                    <a onClick={(e) => openLighboxMobile(e, 0)}>
                                    <ImageModule ImageSrc={hit} attr={{ alt: props.data.display_address }} ggfx_results={props.data.ggfx_results} imagename="property.images.similarpropertytile" strapi_id={props?.data?.id} />

                                    {/* <ImageTransform imagesources={hit.url} renderer="srcSet" imagename='property.images.similarpropertytile'
                              attr={{ alt: '', className: '' }}
                              imagetransformresult={processedImages2} id={props?.data?.id} >

                                    </ImageTransform> */}
                                    </a>
                                    {i === 0 && props.data?.virtual_tour ? 
                            <CustomVideoPlay title={props.data?.title} url={props.data?.virtual_tour}/> : null}
                                    {/* <span class="video-btn" onClick={(e) => {setPlaying(true)}} ><i class="icon-video"></i></span> */}
                                </div>
                            </div>   
                        </div>
                        </ScrollAnimation>
                        )
                    })}
                        
                    </Slider>
                    </div>
                </Container>
                
            </section>
        </React.Fragment>
    )
}

export default PropertyDescription;